import {
  Button,
  CounterMono,
  Flex,
  InputTextArea,
  RadioButtonsGroup,
  SpacingVertical,
  Text,
  Title,
  Link,
  Panel,
  LINK_VARIANT_HIGHLIGHT,
} from "mailup-web-components";
import React, { type FC, useEffect, useMemo, useRef, useState } from "react";
import { useIntl } from "react-intl";
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import styled from "@emotion/styled";
import {
  copyPasteChannelTypeState,
  copyPasteExtractedState,
  copyPasteIsDirtyTextAreaState,
  copyPasteProcessedState,
  copyPasteTextState,
} from "../../recoil/state/stateCopyPaste";
import { extractCopyPasteCallback } from "../../recoil/callbacks";
import { openHelp } from "Helpers/openHelp";
import { notifyParent } from "mailup-react-helpers";

const CopyPasteStep: FC = () => {
  const intl = useIntl();
  const [channelType, setChannelType] = useRecoilState(
    copyPasteChannelTypeState,
  );
  const [text, setText] = useRecoilState(copyPasteTextState);
  const extracted = useRecoilValue(copyPasteExtractedState);
  const processed = useRecoilValue(copyPasteProcessedState);

  const setIsDirtyTextAreaState = useSetRecoilState(
    copyPasteIsDirtyTextAreaState,
  );
  const extractCopyPaste = useRecoilCallback(extractCopyPasteCallback, []);

  const onChangeChannelType = (value: string) => {
    setChannelType(value as "Email" | "MobileNumber");
  };

  const onChangeText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setIsDirtyTextAreaState(true);
    setText(e.target.value);
  };

  const goToDoc = () => {
    notifyParent("openHelp", [openHelp("importCopyAndPasteGuide")]);
  };

  const title =
    channelType === "Email"
      ? intl.formatMessage({ id: "Load.FileImport.CopyPasteTitleEmail" })
      : intl.formatMessage({ id: "Load.FileImport.CopyPasteTitleSms" });

  const description =
    channelType === "Email"
      ? intl.formatMessage(
          { id: "Load.FileImport.CopyPasteDescrEmail" },
          {
            strong: (chunks) => <strong>{chunks}</strong>,
          },
        )
      : intl.formatMessage(
          { id: "Load.FileImport.CopyPasteDescrSms" },
          {
            linebreak: <br />,
            strong: (chunks) => <strong>{chunks}</strong>,
            link: (chunks) => (
              <Link variant={LINK_VARIANT_HIGHLIGHT} onClick={goToDoc}>
                {chunks}
              </Link>
            ),
          },
        );

  const count = processed ? String(extracted.length) : "0";

  return (
    <Panel>
      <RadioButtonsGroup
        onChange={onChangeChannelType}
        items={[
          {
            label: intl.formatMessage({
              id: "Load.FileImport.CopyPasteChannelEmail",
            }),
            value: "Email",
          },
          {
            label: intl.formatMessage({
              id: "Load.FileImport.CopyPasteChannelSms",
            }),
            value: "MobileNumber",
          },
        ]}
        value={channelType}
      />
      <SpacingVertical />
      <Title variant="M">{title}</Title>
      <SpacingVertical variant="16" />
      <Text variant={"light"}>{description}</Text>
      <SpacingVertical />
      <StyledInputTextArea
        value={text}
        onChange={onChangeText}
        placeholder={intl.formatMessage({
          id: "Load.FileImport.CopyPasteTextareaPlaceholder",
        })}
        rows={10}
      />
      <StyledPanel>
        <Flex justifyContent="end">
          <CounterMono
            label={intl.formatMessage({
              id: "Load.FileImport.CopyPasteCounter",
            })}
            count={count}
          />
        </Flex>
      </StyledPanel>
      <Flex justifyContent="end">
        <Button
          onClick={extractCopyPaste}
          disabled={text.trim().length === 0}
          kind="secondary"
        >
          {intl.formatMessage({
            id: "Load.FileImport.CopyPasteButtonExtract",
          })}
        </Button>
      </Flex>
    </Panel>
  );
};

export default CopyPasteStep;

const StyledInputTextArea = styled(InputTextArea)`
textarea{
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
`;

const StyledPanel = styled(Panel)`
  border-radius: 4px !important;
border-top: 0 !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  padding: 12px !important;

`;
